export const USER_EMAIL_MAX_LENGTH = 255;
export const USER_NAME_MAX_LENGTH = 50;
export const USER_PHONE_MAX_LENGTH = 15;
